/* Draft-theme navigation only. Never changes live catalog template assignments. */
(() => {
  if (!['unpublished', 'development'].includes(window.Shopify?.theme?.role)) return;
  const themeId = String(window.Shopify.theme.id);
  const templates = {
    'products/astrobrew-cold-brew-coffee-machine': 'astrobrew-machine',
    'products/polaris': 'astrobrew-polaris',
    'products/auriga': 'astrobrew-auriga',
    'products/ursa': 'astrobrew-ursa',
    'products/orion': 'astrobrew-orion',
    'products/pisces': 'astrobrew-pisces',
    'collections/premium-coffee': 'astrobrew-coffee',
  };

  function destination(href, label = '', preserveMachineProduct = false) {
    let url;
    try { url = new URL(href, window.location.href); }
    catch { return null; }
    if (url.origin !== window.location.origin) return null;
    // Page assignments and menus are shared with production. Resolve the
    // approved Machine destination only inside the unpublished preview.
    const machinePage = /\/pages\/(?:astrobrew-machine|machine-d|machine)\/?$/.test(url.pathname);
    const machineNavigation = !preserveMachineProduct &&
      /^(?:(?:astrobrew\s+)?machine(?: page)?|product listing|learn more|meet (?:the )?(?:astrobrew )?machine|explore (?:the )?(?:astrobrew )?machine|discover (?:astrobrew|the brewer)|(?:see|view) (?:the )?machine|see how it works)$/i.test(label.trim().replace(/[→↗↓]/g, '').trim()) &&
      /\/products\/astrobrew-cold-brew-coffee-machine\/?$/.test(url.pathname);
    if (machinePage || machineNavigation) {
      url.pathname = url.pathname.replace(/\/(?:pages|products)\/[^/]+\/?$/, '/pages/astrobrew-machine');
      // The assigned product-details template now contains the approved native
      // Machine page in this draft. No alternate-template override is needed.
      url.searchParams.delete('view');
      url.searchParams.set('preview_theme_id', themeId);
      return url.href;
    }
    // Preserve Shopify locale prefixes, variants, other query parameters and anchors.
    const resource = url.pathname.match(/(?:^|\/)((?:products|collections)\/[^/]+)\/?$/)?.[1];
    // The additive calculator view is intentional; do not redirect it back to shopping.
    if (resource === 'collections/premium-coffee' && url.searchParams.get('view') === 'coffee-dna') return null;
    const view = templates[resource];
    if (!view) return null;
    url.searchParams.set('view', view);
    url.searchParams.set('preview_theme_id', themeId);
    return url.href;
  }

  const currentDestination = destination(window.location.href);
  // Shopify consumes preview_theme_id into its preview session and removes it
  // from the URL. Only redirect for a missing/wrong view, never to restore that ID.
  if (currentDestination &&
      (new URL(currentDestination).pathname !== new URL(window.location.href).pathname ||
       new URL(currentDestination).searchParams.get('view') !==
       new URL(window.location.href).searchParams.get('view'))) {
    window.location.replace(currentDestination);
    return;
  }

  function updateLink(anchor) {
    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    const next = destination(href, (anchor.textContent || '').replace(/\s+/g, ' '),
      !!anchor.hasAttribute?.('data-ab-store-machine-product') ||
      !!anchor.closest?.('.abpd-payment-note'));
    if (next && anchor.href !== next) anchor.href = next;
  }

  function updateLinks(root) {
    if (root instanceof Element && root.matches('a[href]')) updateLink(root);
    root.querySelectorAll?.('a[href]').forEach(updateLink);
  }

  updateLinks(document);
  // Includes Dawn recommendations, cart links and Theme Editor section reloads.
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') updateLink(record.target);
      else record.addedNodes.forEach(updateLinks);
    });
  }).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['href'],
  });
  document.addEventListener('click', (event) => {
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (anchor) updateLink(anchor);
  }, true);
})();
